import React from 'react';
import { Icon } from './Icon.js';
export const IconFile = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m4,7h3c.552,0,1-.448,1-1v-3", fill: "currentColor", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("path", { d: "m16,14v-8c0-1.657-1.343-3-3-3h-4.586c-.265,0-.52.105-.707.293l-3.414,3.414c-.188.188-.293.442-.293.707v6.586c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3Z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconFile.js.map